import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import location from "../assets/images/icons/ubi.svg";
import call from "../assets/images/icons/call.svg";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import GetInTuch from "../components/getInTuch";
import { FiHexagon } from "../assets/icons/vander";
import Navbar from "../components/navbar";
import useStore from "../store/useStore";
import HeroComex from "../components/HeroComex";
import ContactoAgenda from "../components/ContactoAgenda";

// Página de contacto principal
export default function ContactUs() {
  const { contactosHeroes, getContactosHeroes } = useStore();

  useEffect(() => {
    getContactosHeroes();
  }, [getContactosHeroes]);

  return (
    <div className="bg-sidom-blue">
      <Navbar tabIndex={0} aria-label="Navegación principal" />
      {contactosHeroes &&
        contactosHeroes.map((item, index) => (
          <HeroComex
            key={index}
            video={item.video[0]?.url}
            titulo="Contáctese con Nosotros"
            subtitulo=""
            height="h-[300px]"
            tabIndex={0}
            aria-label="Hero de contacto"
            titleClassName="text-sidom-orange text-2xl md:text-4xl lg:text-5xl font-extrabold text-center mb-5 drop-shadow-lg"
          />
        ))}

      <ContactoAgenda />

      {/* Sección principal de contacto */}
      <section
        aria-label="Información de contacto de SIDOM"
        className="relative md:pb-24 pb-16"
        tabIndex={0}
      >
        {/* <GetInTuch tabIndex={0} aria-label="Formulario de contacto" /> */}
        <GetInTuch
          title="O bien, envíenos su consulta:"
          titleClassName="text-sidom-light text-3xl md:text-4xl font-light text-center mb-8 md:mb-12"
        />
        <div className="container relative lg:mt-24 mt-16">
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px]">
            {/* Tarjeta de contacto telefónico */}
            <div
              className="text-center px-2 md:px-6 lg:px-6"
              tabIndex={0}
              aria-label="Tarjeta de contacto telefónico"
            >
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28  mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  <img
                    src={call}
                    alt="Teléfono"
                    className="h-8 w-8"
                    tabIndex={0}
                    aria-label="Icono de teléfono"
                  />
                </div>
              </div>

              <div className="content mt-7">
                <p
                  className="title text-sidom-light text-lg font-medium"
                  tabIndex={0}
                  aria-label="Título: Teléfono"
                >
                  Teléfono
                </p>
                <p
                  className="text-sidom-light  mt-3"
                  tabIndex={0}
                  aria-label="Descripción: Estamos a disposición para iniciar el salto al siguiente nivel"
                >
                  Estamos a disposición para iniciar el salto al siguiente
                  Nivel.
                </p>
                <div className="mt-5">
                  <Link
                    to="tel:+5491137241700"
                    className="text-orange-500 hover:text-orange-500 after:bg-orange-500 transition duration-500"
                    tabIndex={0}
                    aria-label="Enlace para llamar al teléfono"
                  >
                    Llamar
                  </Link>
                </div>
              </div>
            </div>

            {/* Tarjeta de contacto por email */}
            <div className="text-center px-2 md:px-6 lg:px-6">
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28  mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  {/* Correo: icono sobre moderno */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-8 w-8"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25H4.5a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-.876 1.8l-7.5 5.625a2.25 2.25 0 01-2.748 0l-7.5-5.625a2.25 2.25 0 01-.876-1.8V6.75"
                    />
                  </svg>
                </div>
              </div>

              <div className="content mt-7">
                <p className="title  text-sidom-light text-lg font-medium">
                  Email
                </p>
                <p className="text-sidom-light  mt-3">
                  Nuestro equipo responderá de inmediato a su solicitud.
                </p>
                <div className="mt-5">
                  <Link
                    to="mailto:contact@example.com"
                    className="text-orange-500 hover:text-orange-500 after:bg-orange-500 transition duration-500"
                    aria-label="Enviar correo a SIDOM"
                  >
                    comercial@sidom.io
                  </Link>
                </div>
              </div>
            </div>

            {/* Tarjeta de ubicación */}
            <div className="text-center px-2 md:px-6 lg:px-6">
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28 mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-sidom-orange rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  {/* Ubicación: icono pin moderno */}
                  <img
                    src={location}
                    alt="Ubicación"
                    className="h-8 w-8"
                    aria-hidden="true"
                  />
                </div>
              </div>

              <div className="content mt-7">
                <p className="title text-sidom-light text-lg font-medium">
                  Headquarter
                </p>
                <p className="text-sidom-light mt-3">
                  Camila O’Gorman 412
                  <br />
                  Puerto Madero, Argentina
                </p>
                <div className="mt-5">
                  <Link
                    to="https://www.google.com.ar/maps/place/SIDOM+Suite/@-34.6192574,-58.379665,14z/data=!4m6!3m5!1s0x95a334d005155555:0xac796e0af9c935da!8m2!3d-34.6210634!4d-58.3606355!16s%2Fg%2F11vlprhhmc?entry=ttu&g_ep=EgoyMDI1MDYyOS4wIKXMDSoASAFQAw%3D%3D"
                    data-type="iframe"
                    className="video-play-icon read-more lightbox text-sidom-orange hover:text-orange-500 after:bg-sidom-orange transition duration-500"
                    aria-label="Ver ubicación de SIDOM en Google Maps"
                  >
                    ver en Google Maps
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Mapa de Google con ubicación */}
      <div
        className="container-fluid relative"
        aria-label="Mapa de ubicación de SIDOM"
      >
        <div className="grid grid-cols-1">
          <div className="w-full leading-[0] border-0">
            <div
              className="map-container"
              aria-label="Mapa de ubicación de SIDOM"
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.3395784201375!2d-58.36347962425906!3d-34.62085797294811!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a3358af2c37b9d%3A0x2dd4647f7b035820!2sCamila%20O&#39;Gorman%20412%2C%20C1107%20Cdad.%20Aut%C3%B3noma%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1752500437682!5m2!1ses!2sar"
                width="100%"
                height="450"
                style={{ border: "0" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa de ubicación de SIDOM en Buenos Aires"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      {/* Footer y switcher de tema */}
      <Footer tabIndex={0} aria-label="Pie de página" />
      <Switcher tabIndex={0} aria-label="Botón para cambiar tema" />
    </div>
  );
}
